import axios from 'axios'
const intervals = {
	'1': '1m',
	'3': '3m',
	'5': '5m',
	'15': '15m',
	'30': '30m',
	'60': '1h',
	'120': '2h',
	'240': '4h',
	'360': '6h',
	'480': '8h',
	'720': '12h',
	'D': '1d',
	'1D': '1d',
	'3D': '3d',
	'W': '1w',
	'1W': '1w',
	'M': '1M',
	'1M': '1M'
}

// export const getExchangeServerTime = () => request('/time').then(res => res.serverTime)



// https://binance-docs.github.io/apidocs/spot/en/#kline-candlestick-data
export const getKlines = ({ symbol, interval, from, to }) => {
	interval = intervals[interval] // set interval
	return request('/getData', { asset: 'BINANCE:'+symbol, tf:interval=='30m'?'30':(interval=='1h'?'60':(interval=='4h'?'240':(interval=='1d'?'1440':'10080'))), startTime: from, endTime: to })
	.then(res => {
		console.log("==================")
		console.log(res.length)
		var data = [];
		for (var i=res.length-1; i>=0; i--){
			data.push({
				time: parseFloat(res[i].time * 1000),
				open: parseFloat(res[i].open),
				high: parseFloat(res[i].high),
				low: parseFloat(res[i].low),
				close: parseFloat(res[i].close),
				volume: parseFloat(res[i].volume)
			})
		}
		return data
		// return res.map(i => ({
		// 	time: parseFloat(i.time * 1000),
		// 	open: parseFloat(i.open),
		// 	high: parseFloat(i.high),
		// 	low: parseFloat(i.low),
		// 	close: parseFloat(i.close),
		// 	volume: parseFloat(i.volume),
		// }))
	})
}

export const subscribeKline = ({ symbol, interval, uniqueID }, callback) => {
	// interval = intervals[interval] // set interval
	// return api.stream.kline({ symbol, interval, uniqueID }, res => {
	// 	const candle = formatingKline(res.kline)
	// 	alert(candle);
	// 	callback(candle)
	// })
	return request('/lastCandle', { asset: 'BINANCE:'+symbol, tf:interval})
	.then(res => {
		const candle = formatingKline(res)
		callback(candle)
	})
}

// export const unsubscribeKline = (uniqueID) => {
// 	return api.stream.close.kline({ uniqueID })
// }

export const checkInterval = (interval) => !!intervals[interval]

// helpers ------------------------

function formatingKline({ time, open, high, low, close, volume }) {
	return {
		time: time *1000,
		open,
		high,
		low,
		close,
		volume,
	}
}

function request(url, params = {}) {
	return axios({
		baseURL: '//data.tradingapp.pro/',
		method: 'get',
		url,
		params
	})
		.then(res => res.data)
		.catch(res => console.log(res))
}

function candle(i) {
	return {
		o: parseFloat(i[1]),
		h: parseFloat(i[2]),
		l: parseFloat(i[3]),
		c: parseFloat(i[4]),
		v: parseFloat(i[5]),
		ts: i[0],
		price: parseFloat(i[4]),
		openTime: i[0],
		closeTime: i[6],
		trades: i[8]
	}
}


// WEBPACK FOOTER //
// ./src/components/api/helpers.js